/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillingDto } from '../../models/billing-dto';

export interface BillingGetallfacilityphysandreferrings$Params {
  emrpracticeId?: string | null;
}

export function billingGetallfacilityphysandreferrings(http: HttpClient, rootUrl: string, params?: BillingGetallfacilityphysandreferrings$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDto>> {
  const rb = new RequestBuilder(rootUrl, billingGetallfacilityphysandreferrings.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BillingDto>;
    })
  );
}

billingGetallfacilityphysandreferrings.PATH = '/providers/getallfacilityphysandreferrings';
